export const opModeNameColors: { [name: string]: string } = {
	dp: "#193cbc",
	"dp/standby": "#193cbc",
	standby: "#4382c8",
	port: "#84afdc",
	"port - maneuvering": "#84afdc",
	"port - moored": "#c5dff2",
	"transit other": "#ab6f63", //"#b6b6b6",
	"transit eco": "#2ca02c",
	"transit manuvering": "#ffd700",
	"transit service": "#ffd700",
	"transit max": "#f47e68",
	loading: "#745c9b",
	unloading: "#5422a7",
	ah: "#745c9b",
	"anchor handling": "#745c9b",
	tow: "#5422a7",
	towing: "#5422a7",
	//sølvtrans modes
	operation: "#193cbc",
	maneuvering: "#3794b6",
	"transit ballast": "#b0d757",
	"transit laden": "#f47e68",
	//unisea modes
	"dp operations": "#193cbc",
	"in port (incl. mob/demob and at anchor)": "#84afdc",
	"standby on location and/or waiting on weather": "#4382c8",
	"transit service speed": "#ffd700",
	//altera modes
	"dp 1000m": "#0050ac",
	"dp maneuvering": "#3794b6",
	"drift/waiting": "#ffd600",
	"port/loading": "#b9dbdc",
	discharge: "#999999",
	anchorage: "#e3365c",
	manuvering: "#3794b6",
	"sailing ballast": "#b0d757",
	"sailing laden": "#f47e68",
	"(na)": "#ffffff",
	"port mobilization": "#c5dff2",
	"unknown mode": "#949191", //"#f20acbaa",
	transit: "#2ca02c",
	"waiting for weather": "#745c9b",
	"dp safety zone": "#00dce3",
	"transit harbour": "#ab6f63",
	"transit battery": "#b0d757",
	"dp ah": "#745c9b",
	survey: "#43355a",
	seismic: "#a588d3",
}

export function getColorOfOpModeName(opModeName: string) {
	const lowerCaseOpModeName = opModeName.toLowerCase()
	if (lowerCaseOpModeName in opModeNameColors) {
		return opModeNameColors[lowerCaseOpModeName]
	}
	return undefined
}

export const sortedModesOrder: { [key: string]: number } = {
	DP: 10,
	"DP 1000m": 11,
	"DP/Standby": 12,
	Operation: 13,
	Manuvering: 14,
	"DP maneuvering": 15,
	"DP Maneuvering": 16,
	Maneuvering: 17,
	"DP safety zone": 18,

	Standby: 20,
	"Drift/waiting": 21,
	"Waiting for weather": 22,

	Port: 30,
	"Port/loading": 31,
	"Port - maneuvering": 32,
	"Port - moored": 33,

	Transit: 40,
	"Transit harbour": 41,
	"Transit battery": 42,
	"Transit eco": 43,
	"Transit manuvering": 44,
	"Transit service": 45,
	"Transit max": 46,
	"Transit other": 47,
	"Transit ballast": 48,
	"Transit laden": 49,

	Loading: 50,
	Unloading: 60,
	AH: 70,
	"DP AH": 19,
	Tow: 80,
	Towing: 81,

	//ALTERA MODES
	Discharge: 40,
	Anchorage: 50,
	"Sailing ballast": 70,
	"Sailing laden": 80,
	Survey: 90,
	Seismic: 91,
}
